import ApplicationSerializer from 'eflex/serializers/application';

export default class ServerStatusSerializer extends ApplicationSerializer {
  attrs = {
    links: {
      embedded: 'always',
    },
  };
}
